
export default (function (Drupal, drupalSettings, once) {

  Drupal.behaviors.accordion = {
    attach: function (context, settings) {
      const accordions = once('accordion', document.querySelectorAll('.p1-accordion'));

      function openContainer(container) {
        container.classList.add('p6-content-items--open');
        container.style.height = 'auto';

        let height = (container.clientHeight + 16) + "px";

        container.style.height = '0px';

        setTimeout(function () {
          container.style.height = height;
        }, 0);
      }

      accordions.forEach(accordion => {
        const contentItems = accordion.querySelectorAll('.p6-content-items');

        contentItems.forEach((item, index) => {
          const heading = item.querySelector('.p6-content-items__heading')
          const text = item.querySelector('.p6-content-items__text')

          // open first item by default
          if (index == 0) {
            heading.classList.toggle('p6-content-items--open');
            openContainer(text);
          }

          heading.addEventListener('click', () => {

            heading.classList.toggle('p6-content-items--open');

            if (!text.classList.contains('p6-content-items--open')) {
              openContainer(text);

            } else {
              text.style.height = '0px';

              text.addEventListener('transitionend', function () {
                text.classList.remove('p6-content-items--open');
              }, {
                once: true
              });
            }
          })
        })
      })

      // Change Container Height on resize
      window.addEventListener('resize', () => {
        const containers = document.querySelectorAll('.p6-content-items__text');
        containers.forEach(container => {
          if (container.classList.contains('p6-content-items--open')) {
            container.style.height = (container.children[0].clientHeight + 16) + 'px';
          }
        })
      })
    },
  };
})(Drupal, drupalSettings, once);
